var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{attrs:{"icon":"plus","icon_style":_vm.iconStyle,"custom_style":_vm.buttonStyle,"label":_vm.$t('BOOK_SHOOT')},nativeOn:{"click":function($event){return _vm.$router.push({ name: _vm.redirectRoute })}}})}
var staticRenderFns = []

export { render, staticRenderFns }